<div class="beszerzes">

  <div class="beszerzes__head">
    <div class="beszerzes__head-main">
      <h1 class="stk-page-title">Beszerzés</h1>
      <div class="stk-page-sub">Vásárolt alkatrészek utántöltése — ezeket nem gyártjuk, hanem vesszük.</div>
    </div>
    <button type="button" class="beszerzes__refresh" (click)="refresh()" [disabled]="loading"
            title="Lista újrarendezése és a kész tételek eltávolítása">
      Lista frissítése<span *ngIf="hasCompletedRows"> · kész tételek</span>
    </button>
  </div>

  <div class="pur-stats" *ngIf="!loading && !loadFailed">
    <div class="pur-stat">
      <div class="pur-stat__label">Beszerzendő</div>
      <div class="pur-stat__value">{{ totalPieces }} db</div>
      <div class="pur-stat__sub">{{ taskCount }} tétel</div>
    </div>
    <div class="pur-stat">
      <div class="pur-stat__label">Becsült költség</div>
      <div class="pur-stat__value">{{ costLabel }}</div>
      <div class="pur-stat__sub" *ngIf="!missingPriceCount">beszerzési árak alapján</div>
      <div class="pur-stat__sub pur-stat__sub--warn" *ngIf="missingPriceCount">
        {{ missingPriceCount }} tételnél hiányzik az ár
      </div>
    </div>
  </div>

  <div class="pur-list" *ngIf="!loading">

    <div class="pur-task" *ngFor="let row of rows; trackBy: trackBySku" [attr.data-sku]="row.task.sku"
         [ngClass]="'pur-task--' + row.tone" [class.pur-task--done]="row.done">
      <div class="pur-task__top">
        <img *ngIf="row.task.imageFile" class="pur-task__img"
             [appFetchComponentImage]="row.task.imageFile" [alt]="row.task.name">
        <div *ngIf="!row.task.imageFile" class="pur-task__img pur-task__img--placeholder">kép</div>

        <div class="pur-task__main">
          <div class="pur-task__name-row">
            <span class="pur-task__name">{{ row.task.name }}</span>
            <span class="pur-badge pur-badge--bought">Vásárolt</span>
            <span class="stk-pill pur-badge" [ngClass]="row.badgeClass" *ngIf="!row.done">{{ row.badgeLabel }}</span>
            <span class="pur-badge pur-badge--ok" *ngIf="row.done">Megvan a cél</span>
            <span class="pur-badge pur-badge--logged" *ngIf="row.justReceived > 0">+{{ row.justReceived }} db bevételezve</span>
          </div>
          <div class="pur-task__meta">{{ row.meta }}</div>
        </div>

        <div class="pur-task__col">
          <div class="pur-task__col-label">Készleten</div>
          <div class="pur-task__stock" [class.pur-task__stock--out]="(row.task.stock || 0) <= 0">{{ row.task.stock || 0 }} db</div>
        </div>

        <div class="pur-task__col pur-task__col--need">
          <div class="pur-task__col-label">Beszerzendő</div>
          <button type="button" class="pur-task__need" (click)="fillNeeded(row)"
                  title="Ennyit írok a bevételezés mezőbe">{{ row.task.need }} db</button>
          <div class="pur-task__cost">{{ row.costLabel }}</div>
        </div>

        <div class="pur-task__log">
          <input #qty class="pur-task__input" [value]="inputs[row.task.sku] || ''"
                 (input)="onQtyInput(row.task.sku, qty)" (keydown.enter)="receive(row)"
                 placeholder="megérkezett db" size="4">
          <button type="button" class="pur-task__btn" [class.pur-task__btn--on]="canReceive(row.task.sku)"
                  [disabled]="!canReceive(row.task.sku)" (click)="receive(row)"
                  title="Megérkezett darabok hozzáadása a készlethez">Bevételezés</button>
        </div>
      </div>

      <div class="pur-task__progress">
        <div class="pur-task__bar">
          <div class="pur-task__fill" [class.pur-task__fill--red]="row.progRed" [style.width.%]="row.pct"></div>
        </div>
        <span class="pur-task__prog-label">{{ row.progLabel }}</span>
      </div>
    </div>

    <!-- Üres állapot: minden vásárolt alkatrész minimum felett -->
    <div class="pur-empty" *ngIf="!loadFailed && rows.length === 0">
      <div class="pur-empty__icon">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#4C7A2E" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><polyline points="4,12.5 9.5,18 20,6"></polyline></svg>
      </div>
      <div class="pur-empty__title">Minden vásárolt alkatrész minimum szint felett van</div>
      <div class="pur-empty__sub">Nincs beszerzési feladat. Új rendelés vagy készletmozgás után frissül a lista.</div>
    </div>

    <div class="pur-empty" *ngIf="loadFailed">
      <div class="pur-empty__icon pur-empty__icon--muted">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#707870" stroke-width="2" stroke-linecap="round"><circle cx="12" cy="12" r="9"></circle><line x1="12" y1="11" x2="12" y2="16"></line><circle cx="12" cy="8" r="0.4" fill="#707870"></circle></svg>
      </div>
      <div class="pur-empty__title">A beszerzési lista nem érhető el</div>
      <div class="pur-empty__sub">A beszerzési feladatlista még nem válaszol — próbáld meg később újra.</div>
    </div>

  </div>

</div>
